import React, { useState } from 'react';
import './area.css';
import tobaccoImage from '../json-src/image/tobacco.jpg.webp'; 
import alcoholDrugsImage from '../json-src/image/alcohol.jpeg';
import socialMediaImage from '../json-src/image/social_media.jpeg';

const awarenessData = {
  tobacco: {
    title: "Tobacco Awareness",
    description: "Awareness about tobacco consumption includes understanding its health risks, including lung cancer, heart disease, and respiratory problems. Programs focus on prevention and cessation support.",
    image: tobaccoImage
  },
  alcoholAndDrugs: {
    title: "Alcohol and Drugs Awareness",
    description: "Awareness campaigns about alcohol and drug use highlight the dangers of substance abuse, its impact on mental health, and the importance of seeking help for addiction.",
    image: alcoholDrugsImage
  },
  socialMediaAddiction: {
    title: "Social Media Addiction Awareness",
    description: "Awareness of social media addiction involves understanding its effects on mental health, social interactions, and the importance of balancing online and offline life.",
    image: socialMediaImage
  }
};

const Area = () => {
  const [selectedArea, setSelectedArea] = useState(null);

  const handleChange = (area) => {
    setSelectedArea(area);
  };

  return (
    <div className="area-container">
      <h2>Select an Area of Awareness</h2>
      <div className="cards-container">
        {Object.keys(awarenessData).map((area) => (
          <div
            key={area}
            className={`card ${selectedArea === area ? 'active' : ''}`}
            onClick={() => handleChange(area)}
          >
            <img src={awarenessData[area].image} alt={awarenessData[area].title} className="card-image" />
            <h3>{awarenessData[area].title}</h3>
          </div>
        ))}
      </div>

      {selectedArea && (
        <div className="awareness-info">
          <h3>{awarenessData[selectedArea].title}</h3>
          <p>{awarenessData[selectedArea].description}</p>
        </div>
      )}
    </div>
  );
};

export default Area;
